import { useEffect, useState } from 'react'
import WellViewButtons from '../../../../../../components/wells/well-view-buttons'
import { useGetWellData } from '../../../../../../hooks/use-api'
import { useParamsOr404 } from '../../../../../../hooks/use-params-or-404'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  ButtonsContainer,
  FormField,
  Heading,
  InputWidth,
  ReadOnlyField,
  RecordContent,
  RecordFooter,
  useTitleChange,
} from '@msaf/core-react'

interface WellFileProps {
  dateAdded: string
  documentDescription: string
  documentType: string
  documentReference: string
  documentLinkUrl?: string
  documentLinkIsPublic?: boolean
}

export default function ViewExternalDocumentReference() {
  useTitleChange('View Well | Aquifer')
  const [fields, setFields] = useState<Partial<WellFileProps>>({})
  const { id, externalDocumentReferencesId } = useParamsOr404('id', 'externalDocumentReferencesId')
  const backUrl = `/wells/${id}/view/external-document-references`
  const url = `/wells/${id}/external-document-references/${externalDocumentReferencesId}/view`
  const { isLoading, isSuccess, data } = useGetWellData(url)
  const navigate = useNavigate()

  useEffect(() => {
    if (isSuccess && data?.state) {
      setFields(data.state)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data?.state])

  return (
    <>
      <RecordContent>
        <ButtonsContainer containerStyle='left'>
          <Button
            onClick={() => navigate(backUrl)}
            label='Back'
            iconAlignment='left'
            icon='arrow-left'
            buttonStyle='text-action'
            isSkeleton={isLoading}
          />
        </ButtonsContainer>
        <Heading isSkeleton={isLoading} level={2}>
          External document reference
        </Heading>
        <FormField isSkeleton={isLoading} labelId='dateAdded' label='Date added'>
          <ReadOnlyField
            fieldSize={InputWidth.large}
            isSkeleton={isLoading}
            labelledBy='dateAdded'
            value={`${fields.dateAdded ?? ''}`}
          />
        </FormField>
        <FormField isSkeleton={isLoading} labelId='documentDescription' label='Document description'>
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='documentDescription'
            value={fields?.documentDescription ?? ''}
          />
        </FormField>
        <FormField isSkeleton={isLoading} labelId='documentType' label='Document type'>
          <ReadOnlyField value={fields.documentType} labelledBy='type' />
        </FormField>
        <FormField isSkeleton={isLoading} labelId='documentReference' label='Document reference'>
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='documentReference'
            value={fields?.documentReference ?? ''}
          />
        </FormField>
        <FormField isSkeleton={isLoading} labelId='documentLinkUrl' label='Link URL'>
          {fields.documentLinkUrl ? (
            <a href={fields.documentLinkUrl} target='_blank' rel='noopener noreferrer'>
              {fields.documentLinkUrl}
            </a>
          ) : (
            <ReadOnlyField isSkeleton={isLoading} labelledBy='documentLinkUrl' value='' />
          )}
        </FormField>
        <FormField isSkeleton={isLoading} labelId='documentLinkIsPublic' label='Public?'>
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='documentLinkIsPublic'
            value={!!fields.documentLinkIsPublic ? 'Yes' : 'No'}
          />
        </FormField>
        <RecordFooter areActionsFixed={true}>
          <WellViewButtons wellId={id} />
        </RecordFooter>
      </RecordContent>
    </>
  )
}
